import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, OnInit, OnDestroy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ProductDataDto } from 'app/models/product-data-dto';
import { ProductService } from 'app/services/product/product.service';
import { Subject, Subscription, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, catchError } from 'rxjs/operators';
import { ImageFallbackDirective } from "app/modules/admin/directives/ImageFallbackDirective";
import { ImageUrlPipe } from 'app/modules/admin/pipe/image-url.pipe';



@Component({
  selector: 'app-product-day-picker-modal',
  standalone:true,
  imports: [CommonModule, FormsModule, ImageFallbackDirective,ImageUrlPipe],
  templateUrl: './product-day-picker-modal.component.html',
  styleUrls: ['./product-day-picker-modal.component.scss']
})
export class ProductDayPickerModalComponent implements OnInit, OnDestroy {
  @Input() isOpen = false;

  // نرجّع الداتا للـ parent
  @Output() close = new EventEmitter<void>();
@Output() saved = new EventEmitter<{
  day: number;
  items: Array<{ product_id: number; value: number }>;
}>();

  // ===== Search =====
  searchText = '';
  showDropdown = false;
  loadingSearch = false;
  searchResults: ProductDataDto[] = [];
// ✅ Days filter
  days = [
    {label:'All',value:0},
    { label: 'Saturday', value: 1 },
    { label: 'Sunday', value: 2 },
    { label: 'Monday', value: 3 },
    { label: 'Tuesday', value: 4 },
    { label: 'Wednesday', value: 5 },
    { label: 'Thursday', value: 6 },
    { label: 'Friday', value: 7 },
  ];

  selectedDay:number= 0;
  private searchSubject = new Subject<string>();
  private searchSub?: Subscription;

  // ===== Selected Table =====
  selectedRows: Array<{ product: ProductDataDto; value: number }> = [];

  constructor(
    // حقنك الحقيقي
    private productService: ProductService
  ) {}

  ngOnInit(): void {
    // Rx pipeline: debounce + cancel previous request (switchMap)
    this.searchSub = this.searchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap((term) => {
        if (!term) {
          this.loadingSearch = false;
          return of({ data: [] } as any);
        }

        this.loadingSearch = true;
        return this.productService.searchProductsTypeZero(term).pipe(
          catchError((err: any) => {
            console.error('Error fetching products:', err);
            return of({ data: [] } as any);
          })
        );
      })
    ).subscribe((res: any) => {
      this.handleSearchResults(res?.data || [], this.searchText);
      console.log(res.data);
    });
  }

  ngOnDestroy(): void {
    this.searchSub?.unsubscribe();
  }

  // ====== Your real functions (adapted for modal) ======
  onSearchChange(event: any): void {
    const term = event.target.value?.trim() || '';
    this.searchText = term;

    if (term === '') {
      this.closeSearchDropdown();
      return;
    }

    this.showDropdown = true;
    this.searchSubject.next(term);
  }

  private handleSearchResults(products: any[], searchTerm: string): void {
    this.searchResults = products;
    this.loadingSearch = false;

    // لو المستخدم مسح النص بسرعة
    if (!searchTerm?.trim()) {
      this.closeSearchDropdown();
    }
  }

  // بدل navigate: ضيف المنتج في جدول المودال
  selectProduct(product: any): void {
    //this.closeSearchDropdown();
    this.showDropdown = true;
    this.searchText = '';
    console.log(product);
    const exists = this.selectedRows.some(r => String(r.product?.id) === String(product?.id));
    if (exists) return;

    this.selectedRows.push({ product, value:product.prod_qty });

  }

  removeRow(productId: number | string): void {
    this.selectedRows = this.selectedRows.filter(r => String(r.product?.id) !== String(productId));
  }

  updateValue(row: { product: ProductDataDto; value: number }, event: Event): void {
    const v = Number((event.target as HTMLInputElement).value);
    row.value = Number.isFinite(v) ? v : 0;
  }

  private closeSearchDropdown(): void {
    console.log("clossssssssssse");
    this.showDropdown = false;
    this.searchResults = [];
    this.loadingSearch = false;
  }

  onSearchFocus(): void {
    if (this.searchText.trim()) {
      this.showDropdown = true;
    }
  }

  onSearchBlur(): void {
    // setTimeout(() => {
    //   this.showDropdown = false;
    // }, 200);
  }

  handleImageError(event: Event): void {
    const img = event.target as HTMLImageElement;
    img.src = 'assets/images/logo/logo.svg';
  }

  // ===== Modal actions =====
  onClose(): void {
    this.isOpen = false;
    this.close.emit();
    this.closeSearchDropdown();
    this.selectedRows = []
    this.searchText = '';
  }
  closeSearch(input: HTMLInputElement): void {
    this.showDropdown = false;
      input.value = '';

  }

  onSave(): void {
    // sanitize numbers
    console.log(this.selectedRows);
    console.log(this.selectedDay);
    const payload = {
              day:  this.selectedDay,
              items:this.selectedRows.map(r => ({
                  product_id: r.product.id,
                  value: Math.max(0, Number(r.value || 0))
                }))};
    console.log(payload);
    this.saved.emit(payload);
    this.onClose();
  }

  trackById = (_: number, item: any) => item?.product?.id ?? item?.id ?? _;
}
